import React from 'react';
import fr from 'facet-rest';
import Autocomplete from 'Components/UI/Autocomplete';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const hiddenFieldNames = [
  'attachments',
  'bccEmailAddresses',
  'canEdit',
  'ccEmailAddresses',
  'content',
  'createdAt',
  'emailSubject',
  'from',
  'fromEmailAddress',
  'isDraft',
  'lastEdit',
  'messageType',
];

const useStyles = buildUseStyles('StyledAutoComplete', () => ({
  root: {
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
  },
}));

const StyledAutoComplete = ({ ...props }) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Autocomplete className={classes.root} {...props} />
  );
};

// eslint-disable-next-line import/prefer-default-export
export const ComposeMessageRecipientsOverrides = fr.metaOverride()
  .nameOverride('messageRecipients', {
    _component: () => StyledAutoComplete,
    _customProps: {
      creatable: true,
      ignoreGroups: true,
      autoSelect: false,
      SelectProps: {
        multiple: true,
      },
      disableClearable: true,
      ChipProps: {
        avatar: true,
        getRootColor: () => {
          return 'secondaryOutlined';
        },
      },
    },
    _hideLabel: true,
  })
  .nameOverride(name => hiddenFieldNames.includes(name), {
    hidden: true,
  });
